import React, { useState, useCallback } from "react"
import { Typography, Dialog, DialogContent, DialogActions, TextField, Stack } from "@mui/material"

import useTranslations from "helpers/hooks/useTranslations";
import DialogTitleWithClose from "components/Dialog/DialogTitleWithClose";
import ErrorAdornment from "components/Common/ErrorAdornment";
import OKCancelControl from "components/Common/OKCancelControl";

interface IProps {
    oldName: string;
    open: boolean;
    close: () => void;
    handleEdit: (name: string) => void;
}

const EditSchedule: React.FC<IProps> = ({oldName, open, close, handleEdit}) => {
    const tm = useTranslations();
    const message = tm.Get("Edit the schedule name.");

    const [newName, setNewName] = useState<string>("");
    const [errorText, setErrorText] = useState<string>("");

    const handleNameChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setNewName(e.target.value);
    }, []);

    const validate = useCallback((name: string) => {
        if (name.trim() === "") {
            return tm.Get("The schedule name cannot be an empty string.")
        }
        return "";
    }, [tm]);

    const handleNameBlur = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
        setErrorText(validate(e.target.value));
    }, [validate]);
    
    const trySubmit = useCallback((name: string) => {
        let error = validate(name);
        if (error === "") {
            handleEdit(name);
        } else {
            setErrorText(error);
        }
    }, [handleEdit, validate]);

    return <>
        <Dialog fullWidth
            onClose={close}
            open={open}
        >
            <DialogTitleWithClose onClose={close}>
                {tm.GetWithParams("Edit {0}", tm.Get("Schedule"))}
            </DialogTitleWithClose>
            <DialogContent>
                <Stack direction="column" alignItems="flex-start" justifyItems="stretch" spacing={2}>
                    <Typography whiteSpace="pre-wrap">
                        {message}
                    </Typography>
                    <TextField size="small" label={tm.Get("Old Name")} value={oldName} fullWidth disabled/>
                    <TextField size="small" label={tm.Get("New Name")} value={newName} onChange={handleNameChange} onBlur={handleNameBlur} fullWidth 
                        error={errorText !== ""}
                        InputProps={{
                            endAdornment: errorText !== "" ? 
                                <ErrorAdornment validationError={errorText}/> : null
                        }}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <OKCancelControl okCommand={() => trySubmit(newName.trim())} cancelCommand={close} />
            </DialogActions>
        </Dialog>
    </>
}

export default EditSchedule;